/** PM Thread View — open/close threads, header updates. */

window.open_active_thread_by_link = function(activeThread) {
  // With column-reverse, scrollTop=0 is the bottom
  let trt = $("#threads_right");
  window.setTimeout(function() {
    if (typeof trt.scrollTo === "function" && trt.length) {
      trt.scrollTo({
        top: 0,
        // Prevent horizontal scrolling
        left: 0,
        behavior: "smooth"
      });
    }
  }, 200);

  window.update_user_header(activeThread.data("thread-id"));

  // Ensure conversation header and message compose box are visible
  $("#conversation-header").removeClass("hidden");
  $("#threads_right_bottom").removeClass("hidden");
};

window.remove_msg_highlighting = function() {
  if (window.messages_highlighted === 0) return;
  if ($("#single_thread_wrapper").length > 0) {
    $("#conversation").find(".pm_new").removeClass("pm_new");
  } else {
    $("#threads_right").find(".pm_new").removeClass("pm_new");
  }
  window.messages_highlighted = 0;
};

window.get_newest_msg_id_in_thread = function() {
  let lm;
  if ($("#single_thread_wrapper").length > 0) {
    // Classic view
    lm = $("#conversation").find(".pm_msg:not(.optimistic-msg):first");
  } else {
    // Split view — skip optimistic messages that haven't been confirmed by server
    lm = $("#threads_right").find(".pm_msg:not(.optimistic-msg):last");
  }
  if (lm.length) {
    return lm.attr("id").replace("msg_", "");
  }
  return false;
};

window.update_change_view_link = function(thread_id) {
  // Update "change_view" link
  var view = window.pm_view_mode === "chat" ? "paged" : "chat";
  if (typeof thread_id == "undefined") {
    $("#change_view").attr("href", "/app/messages?view=" + view);
  } else {
    $("#change_view").attr("href", "/app/messages?view=" + view + "&thread_id=" + thread_id);
  }
};

window.update_user_header = function(thread_id) {
  const thread = $("#thread_" + thread_id);
  $("#current_thread_avatar").attr("src", thread.data("thumb"));
  $("#current_thread_username").text(thread.data("name"));
  $("#current_thread_link").attr("href", thread.data("profile-link"));
  // Clear status until the AJAX response provides the server-rendered text
  $("#current_thread_status").text("");
};

window.update_header_status = function(statusText) {
  $("#current_thread_status").text(statusText || "");
};

window.view_thread = function(thread_id, reload_messages) {
  // Clear reply state when switching to a different thread
  var currentThread = window.get_active_thread_id ? window.get_active_thread_id() : null;
  if (window.cancelReply && (reload_messages || String(thread_id) !== String(currentThread))) window.cancelReply();

  $("#alert_bar").remove();

  var msg = $("#message"),
    tl = $("#threads_left"),
    thread = $("#thread_" + thread_id),
    tm = $("#threads_main"),
    use_browser_cached_draft = typeof window.last_draft[thread_id] != "undefined",
    localDraft = window.draftStorage.load(thread_id);

  // Preserve thread list scroll — guard against reflow-induced resets
  var tlEl = tl[0];
  var _savedScroll = tlEl ? tlEl.scrollTop : 0;
  function _keepScroll() { if (tlEl) tlEl.scrollTop = _savedScroll; }
  // Run a short-lived interval to continuously restore scroll position
  // across all async reflows (style injection, AJAX DOM updates, etc.)
  if (tlEl && _savedScroll > 0) {
    var _guardCount = 0;
    var _scrollGuard = setInterval(function() {
      tlEl.scrollTop = _savedScroll;
      if (++_guardCount >= 30) clearInterval(_scrollGuard);
    }, 10);
    // Also clear guard if user scrolls manually
    var _clearGuard = function() {
      clearInterval(_scrollGuard);
      tlEl.removeEventListener('wheel', _clearGuard);
      tlEl.removeEventListener('touchmove', _clearGuard);
    };
    tlEl.addEventListener('wheel', _clearGuard, { once: true });
    tlEl.addEventListener('touchmove', _clearGuard, { once: true });
  }

  // If reload_messages is false, we only mark thread as active. Without reset form.

  if (reload_messages) {
    // Make 'send message' smaller and make 'message' textarea empty
    $("#threads_main").removeClass("send");
    msg.val("");
    $("#send_thread_id").val(thread_id);
    // Remove autosaved msg
    $("#markitup_msg").empty();
  }

  // Remove "new" in 3 seconds
  window.setTimeout(function() {
    window.remove_new_mark();
  }, 3000);

  // Restore draft from local storage, in-memory cache, or server (via AJAX below)
  if (reload_messages && (localDraft !== null || use_browser_cached_draft)) {
    var draft = localDraft !== null ? localDraft : window.last_draft[thread_id];
    msg.val(draft);
    if (draft) {
      $("#threads_main").addClass("send");
    }
    if (window.updateSendButtonState) window.updateSendButtonState();
  }
  // Remove empty-state placeholder before showing the pane to prevent flash on mobile
  $("#pm-empty-state").remove();

  // With this class '#threads_right' and 'send message' form will be visible
  tm.addClass("threads--open");
  _keepScroll();
  tm.removeClass("pm-placeholder-hidden");
  $("#threads_left_container")[0].style.removeProperty("width");
  $("#threads-right__container").removeClass("hidden").addClass("flex").show();
  $("#separator").show();
  $("#pm-show-placeholder-btn").addClass("hidden").removeClass("flex");
  $("#pm-dismiss-placeholder-btn").addClass("hidden");
  _keepScroll();

  // Show the conversation header and message compose box
  $("#conversation-header").removeClass("hidden");
  $("#threads_right_bottom").removeClass("hidden");
  _keepScroll();

  // Hide jump-to-latest when switching threads (scroll handler will show it if needed)
  $("#jump-to-latest-btn").addClass("hidden").removeClass("flex");

  // Hide any open dropdown menus
  $("#conversation-actions-menu").addClass("hidden");
  $(".thread-actions-menu").addClass("hidden");
  $(".thread-swipe-actions").removeClass("translate-x-0").addClass("translate-x-full");

  // Update responsive layout
  window.threads_main_resize();
  _keepScroll();

  window.update_user_header(thread_id);

  // Remove all old active threads
  tl.find(".pm_thread").removeClass("active");
  // Set new thread as active
  thread.addClass("active");
  _keepScroll();

  // Scroll page to top (use native scrollTo to avoid affecting inner scroll containers)
  if ($(window).height() > 590) {
    window.scrollTo(0, 0);
  }
  _keepScroll();

  window.update_change_view_link(thread_id);

  // If reload_messages is false we only mark thread as active. Without reloading messages.
  if (!reload_messages) return false;

  // Remove new msgs counter
  thread.find(".pm_new_circle").remove();
  // Remove red background
  thread.removeClass("new");

  // Show 'hide thread' button. Remove css class which rendered on server side if any
  var ctw = $("#close_thread_wrap");
  ctw.removeClass("visible");
  ctw.show();

  var c = $("#threads_right");

  // Show a loading spinner while messages load
  c.html('<div id="pm-loading-spinner" class="flex items-center justify-center h-full flex-1"><div class="w-6 h-6 border-2 border-gray-300 border-t-sky-500 rounded-full animate-spin"></div></div>');

  // Pre-position container to bottom before loading to prevent flash
  window.prePositionToBottom(c);

  // Set ajax request marker
  window.pm_ajax_request_active = 1;
  $.ajax({
    type: "POST",
    url: "/app/messages/load",
    data: {
      "thread": thread_id,
      // Skip server draft if we have local data (including explicit empty)
      "load_draft": (localDraft !== null || use_browser_cached_draft) ? 0 : 1
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'thread_opened');
    }
    _keepScroll();
    if (data.body) {
      // Build new wrapper off-DOM, then swap in one operation to avoid blank flash
      var newWrapper = $('<div id="messages_wrapper"></div>');
      newWrapper.append(data.body);
      var oldWrapper = c.find('#messages_wrapper');
      if (oldWrapper.length) {
        oldWrapper.replaceWith(newWrapper);
      } else {
        c.empty();
        c.append(newWrapper);
      }
      // column-reverse: scrollTop=0 is bottom
      c.get(0).scrollTop = 0;
      _keepScroll();
      // Update "last opened by contact" timestamp
      if (typeof data.lobc != "undefined") {
        thread.data("lobc", data.lobc);
      }
      // Update header status from server response
      if (typeof data.contact_status != "undefined") {
        window.update_header_status(data.contact_status);
      }
      // Hide compose box and update header when the contact is inactive/deleted
      if (data.contact_active === false) {
        $("#threads_right_bottom").addClass("hidden");
        if (data.contact_name) {
          $("#current_thread_username").text(data.contact_name);
        }
      }
      // Load draft if any
      if (data.draft.length > 0) {
        msg.val(data.draft);
        $("#threads_main").addClass("send");
        msg[0].dispatchEvent(new Event('input'));
      }

      // Initialize audio players before scrolling so their height is accounted for
      if (window.initAudioPlayers) window.initAudioPlayers();

      // Setup scroll observer for dynamic content
      window.setupScrollObserver(c);

      // Wait for images to load, then scroll to bottom
      window.scrollToBottomAfterImagesLoad(c, 3000);

      // If user prefers paginated view, switch to it after loading
      if (localStorage.getItem('pm_paged_view') === '1') {
        window.activatePagedView();
      }
    } else {
      var errWrapper = $('<div id="messages_wrapper"></div>');
      if (data.error) {
        errWrapper.append(window.err_div.html(data.error));
      } else {
        errWrapper.append(window.err_div.html(window.t('common.pm.conversation_empty')));
      }
      var oldW = c.find('#messages_wrapper');
      if (oldW.length) { oldW.replaceWith(errWrapper); } else { c.empty(); c.append(errWrapper); }
      c.get(0).scrollTop = 0;
    }
    window.focus_msg_box();
  }).fail(function(data, textStatus, jqXHR) {
    var errWrapper = $('<div id="messages_wrapper"></div>');
    errWrapper.append(window.err_div.html(window.err_txt));
    var oldW = c.find('#messages_wrapper');
    if (oldW.length) { oldW.replaceWith(errWrapper); } else { c.empty(); c.append(errWrapper); }
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
  });
  return false;
};

window.close_thread = function(no_history) {
  // If html5 history not supported use redirect
  if (!window.htm5_history_supported) {
    window.location.href = window.location.protocol + "//" +
      window.location.hostname + window.location.pathname;
    return false;
  }

  // Dismiss the virtual keyboard so visualViewport reports the full height
  if (document.activeElement && document.activeElement !== document.body) {
    document.activeElement.blur();
  }

  // Clear keyboard-open state and inline styles from mobile keyboard handling
  var pmContainer = document.querySelector('.privateMessages');
  if (pmContainer) {
    pmContainer.classList.remove('keyboard-open');
    pmContainer.style.removeProperty('height');
    pmContainer.style.removeProperty('top');
  }
  var bottomNav = document.querySelector('[data-component="mobile-bottom-nav"]');
  if (bottomNav) bottomNav.style.display = '';

  window.update_change_view_link();

  let tm = $("#threads_main");
  $("#close_thread_wrap").hide();
  tm.find(".pm_thread").removeClass("active");

  // Hide the conversation header and message compose box
  $("#conversation-header").addClass("hidden");
  $("#threads_right_bottom").addClass("hidden");

  // Hide jump-to-latest and pagination controls
  $("#jump-to-latest-btn").addClass("hidden").removeClass("flex");
  $("#paged-view-controls").addClass("hidden");
  window.pagedViewActive = false;

  // Reset date-jump state and calendar
  if (window.calendarJump) {
    window.calendarJump.close();
    window.calendarJump.dateJumpActive = false;
  }
  window.calendarJump._jumpState = null;
  var trEl = document.getElementById('threads_right');
  if (trEl) trEl.style.flexDirection = 'column-reverse';

  // Clear the send thread ID and message input
  $("#send_thread_id").val("");
  $("#message").val("");

  // Clear photo upload
  if (window.photoUpload) {
    window.photoUpload.removeAllPhotos();
  }

  // Hide any open dropdown menus
  $("#conversation-actions-menu").addClass("hidden");
  $(".thread-actions-menu").addClass("hidden");
  $(".thread-swipe-actions").removeClass("translate-x-0").addClass("translate-x-full");

  // Clear messages and restore the empty-state placeholder
  var $tr = $("#threads_right");
  $tr.empty();
  var title = $tr.data('empty-title') || '';
  var subtitle = $tr.data('empty-subtitle') || '';
  $tr.append(
    '<div id="pm-empty-state" class="flex items-center justify-center h-full text-center flex-1">' +
      '<div class="flex flex-col items-center justify-center max-w-sm px-4">' +
        '<div class="relative w-44 h-36 sm:w-52 sm:h-40 mb-6">' +
          '<img src="/images/favicon.svg" alt="" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 sm:w-24 sm:h-24 drop-shadow-lg" />' +
          '<div class="absolute w-10 h-10 sm:w-12 sm:h-12 top-0 left-4 -rotate-12 bg-blue-100 rounded-xl flex items-center justify-center drop-shadow-md"><i data-lucide="message-circle" class="w-5 h-5 sm:w-6 sm:h-6 text-blue-500"></i></div>' +
          '<div class="absolute w-9 h-9 sm:w-11 sm:h-11 top-1 right-4 rotate-12 bg-emerald-100 rounded-xl flex items-center justify-center drop-shadow-md"><i data-lucide="smile" class="w-5 h-5 sm:w-6 sm:h-6 text-emerald-500"></i></div>' +
          '<div class="absolute w-10 h-10 sm:w-12 sm:h-12 bottom-0 left-6 rotate-6 bg-amber-100 rounded-xl flex items-center justify-center drop-shadow-md"><i data-lucide="globe" class="w-5 h-5 sm:w-6 sm:h-6 text-amber-500"></i></div>' +
          '<div class="absolute w-9 h-9 sm:w-11 sm:h-11 bottom-1 right-6 -rotate-6 bg-purple-100 rounded-xl flex items-center justify-center drop-shadow-md"><i data-lucide="heart" class="w-5 h-5 sm:w-6 sm:h-6 text-purple-500"></i></div>' +
        '</div>' +
        '<h3 class="text-xl sm:text-2xl font-bold text-gray-800 mb-2">' + $('<span>').text(title).html() + '</h3>' +
        '<p class="text-gray-500 text-sm sm:text-base">' + $('<span>').text(subtitle).html() + '</p>' +
      '</div>' +
    '</div>'
  );
  if (window.LucideIcons) window.LucideIcons.initialize($tr[0]);

  // Show the right container but keep it in empty state
  $("#threads-right__container").removeClass("hidden").addClass("flex");
  $("#pm-dismiss-placeholder-btn").removeClass("hidden");

  tm.removeClass("threads--open");

  // Update responsive layout, then apply placeholder preference
  window.threads_main_resize();
  window.applyPlaceholderPreference();

  if (typeof no_history != "undefined" && no_history) {
    return false;
  }

  // Push url to html5 history
  let stateObj = { "close_thread": true };
  history.pushState(stateObj, null, "/app/messages");
};
